"use client";
import React from 'react';

interface EmptyComponentProps {
    sectionBackgroundColor: string;
    sectionContent: string;
}

const EmptyComponent = ({ data }: { data: EmptyComponentProps }) => {

    const sectionBackgroundColor = data.sectionBackgroundColor ? data.sectionBackgroundColor : '#99ADFC1A';
    return (
        <div className="relative flex justify-center flex-col py-8 md:py-10" style={{ backgroundColor: sectionBackgroundColor }}>
            <div className="container mx-auto xl:px-0 px-6">
                <div dangerouslySetInnerHTML={{ __html: data.sectionContent }} />
            </div>
        </div>
    )
}

export default EmptyComponent;